class DeckingCalculatorController {
  constructor() {
    this.containerEl = document.querySelector('.decking-calculator');
    this.colorOptions = document.querySelectorAll('.decking-calculator__color-option');

    this.selectedColor;

    this.pricePerPlank = Number(this.containerEl.dataset.productPrice);
    this.plankAreaInMeters = this.containerEl.dataset.plankArea;

    this.includeWastageSelector = document.querySelector('#decking-calculator__include-wastage');
    this.quantitySelector = document.querySelector('#decking-calculator__quantity-selector');
    this.quantityMinusBtn = document.querySelector('#decking-calculator__quantity-minus');
    this.quantityPlusBtn = document.querySelector('#decking-calculator__quantity-plus');
    this.areaSelector = document.querySelector('#decking-calculator__area-selector');
    this.totalPriceEl = document.querySelector('.decking-calculator__total-price');

    this.orderOverviewEl = document.querySelector('#decking-calculator__order-overview');
    this.orderOverviewProductAmount = document.querySelector('#decking-calculator__order-overview-product-info-amount');
    this.orderOverviewProductPrice = document.querySelector('#decking-calculator__order-overview-product-info-price');
    this.orderOverviewWasteageAmount = document.querySelector('#decking-calculator__order-overview-wasteage-info-amount');
    this.orderOverviewWasteagePrice = document.querySelector('#decking-calculator__order-overview-wasteage-info-price');
    this.orderOverviewWasteageContainer = document.querySelector('#decking-calculator__order-overview-wasteage-container');

    this.errorScreenContainer = document.querySelector('#decking-calculator__error-screen');
    this.errorScreenTitle = document.querySelector('#decking-calculator__error-screen-title');
    this.errorScreenDescription = document.querySelector('#decking-calculator__error-screen-description');
    this.errorScreenConfirmBtn = document.querySelector('#decking-calculator__error-screen-confirm-btn');

    this.addToCartBtnEl = document.querySelector('#add-to-cart-btn');
    this.orderASampleBtn = document.querySelector('#order-a-sample-btn');
    this.closeOrderOverviewBtn = document.querySelector('.decking-calculator__order-overview-close-btn');
    this.continueShoppingBtn = document.querySelector('.decking-calculator__order-overview-actions .continue-shopping');

    // Get media gallery for new theme
    this.mediaGallery = document.querySelector('media-gallery');
  }

  selectColor(element) {
    const { variantId, color, variantQuantity, variantImage, mediaId, mediaIndex } = element.dataset;

    for (let i = 0; i < this.colorOptions.length; i++) {
      const colorOption = this.colorOptions[i];
      colorOption.classList.remove('selected');
    }

    this.selectedColor = {
      id: variantId,
      color,
      quantity: variantQuantity,
      variantImage
    };

    element.classList.add('selected');
    
    // Update gallery for new theme
    this.updateGalleryImage(mediaId, mediaIndex);
  }

  updateGalleryImage(mediaId, mediaIndex) {
    // For new theme with swiper gallery
    if (this.mediaGallery && this.mediaGallery.setActiveMedia) {
      // Create a variant object that matches what setActiveMedia expects
      const mockVariant = {
        featured_media: {
          id: mediaId,
          position: parseInt(mediaIndex) + 1
        }
      };
      
      this.mediaGallery.setActiveMedia(mockVariant);
    }
    // Fallback for live theme or if media gallery not found
    else {
      const primaryImageEl = document.querySelector('#media-gallery #primary-image');
      if (primaryImageEl) {
        primaryImageEl.src = this.selectedColor.variantImage;
      }
    }
  }

  calculateMinWasteagePlanks() {
    return Math.ceil((this.areaSelector.value * 0.05) / this.plankAreaInMeters);
  }

  updatePrice() {
    let price = parseInt(this.quantitySelector.value)  * this.pricePerPlank;

    if (this.includeWastageSelector.checked) {
      const minWasteagePlanks = this.calculateMinWasteagePlanks();

      price = price + minWasteagePlanks * this.pricePerPlank;
      this.orderOverviewWasteageAmount.innerHTML = minWasteagePlanks;
      this.orderOverviewWasteagePrice.innerHTML = `£${(minWasteagePlanks * this.pricePerPlank).toFixed(2)}`
    }

    this.totalPriceEl.innerHTML = `£${(price).toFixed(2)}`;
    this.orderOverviewProductPrice.innerHTML = `£${(price).toFixed(2)}`;
  }

  handleQuantityUpdate() {
    this.areaSelector.value = (this.quantitySelector.value * this.plankAreaInMeters).toFixed(2);
    this.updatePrice();
  }

  handleQuantityIncrement() {
    const currentValue = parseInt(this.quantitySelector.value) || 0;
    this.quantitySelector.value = currentValue + 1;
    this.handleQuantityUpdate();
  }

  handleQuantityDecrement() {
    const currentValue = parseInt(this.quantitySelector.value) || 0;
    if (currentValue > 1) {
      this.quantitySelector.value = currentValue - 1;
      this.handleQuantityUpdate();
    }
  }

  handleAreaUpdate() {
    const planksRequired = Math.ceil(this.areaSelector.value / this.plankAreaInMeters);

    this.quantitySelector.value = planksRequired;
    this.updatePrice();
  }

  displayOrderOverview() {
    this.orderOverviewProductAmount.innerHTML = this.quantitySelector.value;
    this.orderOverviewEl.classList.add('active');
  }

  hideOrderOverview() {
    this.orderOverviewEl.classList.remove('active');
  }

  async addToCart() {
    let quantity = Number(this.quantitySelector.value);

    if (this.includeWastageSelector.checked) {
      quantity += this.calculateMinWasteagePlanks();
    }

    let formData = {
      'items': [{
        'id': this.selectedColor.id,
        'quantity': quantity
      }]
    };

    const res = await fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(formData)
    });

    const orderRequest = await res.json();

    if (orderRequest.status === 422) {
      this.handleError(orderRequest);
    } else {
      this.displayOrderOverview();
    }
  }

  handleError(error) {
    const { message, description } = error;

    this.errorScreenTitle.innerHTML = message;
    this.errorScreenDescription.innerHTML = description;
    this.errorScreenContainer.classList.add('active');
  }

  init() {
    this.selectColor(this.colorOptions[0]);

    for (let i = 0; i < this.colorOptions.length; i++) {
      const element = this.colorOptions[i];
      element.addEventListener('click', (e) => {
        this.selectColor(e.target.closest('.decking-calculator__color-option'));
      });
    }

    this.quantitySelector.value = 1;
    this.handleQuantityUpdate();

    // Add event listeners for quantity buttons
    this.quantityPlusBtn.addEventListener('click', () => {
      this.handleQuantityIncrement();
    });

    this.quantityMinusBtn.addEventListener('click', () => {
      this.handleQuantityDecrement();
    });

    this.addToCartBtnEl.addEventListener('click', () => {
      this.addToCart();
    });

    this.orderASampleBtn.addEventListener('click', (e) => {
      const { sampleUrl } = e.target.dataset;
      window.location.href = sampleUrl || 'https://thegrassyard.myshopify.com/collections/samples';
    });

    this.closeOrderOverviewBtn.addEventListener('click', () => {
      this.hideOrderOverview();
    });

    this.errorScreenConfirmBtn.addEventListener('click', () => {
      this.errorScreenContainer.classList.remove('active');
    });

    this.includeWastageSelector.addEventListener('change', () => {
      if (this.includeWastageSelector.checked) {
        this.orderOverviewWasteageContainer.classList.add('active');
      } else {
        this.orderOverviewWasteageContainer.classList.remove('active');
      }
    });

    this.continueShoppingBtn.addEventListener('click', () => {
      this.hideOrderOverview();
    });

    this.quantitySelector.addEventListener('change', () => {
      this.handleQuantityUpdate();
    });

    this.areaSelector.addEventListener('change', () => {
      this.handleAreaUpdate();
    });

    this.includeWastageSelector.addEventListener('change', () => {
      this.updatePrice();
    });
  }
}